import { render, staticRenderFns } from "./organization-status.vue?vue&type=template&id=a183d9dc"
import script from "./organization-status.vue?vue&type=script&lang=js"
export * from "./organization-status.vue?vue&type=script&lang=js"
import style0 from "./organization-status.vue?vue&type=style&index=0&id=a183d9dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports